import { Grid, CardContent, Typography, Link } from '@mui/material';
import { useDevice } from 'components/DeviceContext.js';

const cardsData = [
  {
    content: 'Combate às drogas: Programa Próvida',
    image: require('imagens/imgCards/cataguases.jpg'),
    link: './programa-pro-vida',
  },
  {
    content:
      'Combate às Drogas: A Viagem de Lucy: Degradação sócio-psico-social da dependência química',
    image: require('imagens/imgCards/balneario.jpg'),
    link: './a-viagem-de-lucy',
  },
  {
    content: 'Combate às Drogas: Serviço de Abordagem Social Multidisciplinar',
    image: require('imagens/imgCards/rondonopolis.jpg'),
    link: './servico-de-abordagem-social-multidisciplinar',
  },
  {
    content:
      'Combate às Drogas: Funcef - Fundação Cultural, Esportiva, Educacional e Ambiental de Formoso do Araguaia',
    image: require('imagens/imgCards/formosodoaraguaia.jpg'),
    link: './funcef',
  },
  {
    content: 'Campos de Júlio/MT tem programa de resistência às drogas',
    image: require('imagens/imgCards/good-idea-yellow.jpg'),
    link: './programa-resistencia-drogas',
  },
];

const BoasPraticas = () => {
  const { isMobile, isLaptop } = useDevice();

  const cardWidth = isMobile ? '100%' : isLaptop ? 320 : 340;

  return (
    <Grid
      container
      style={{
        backgroundColor: '#E5EBEF',
        padding: isMobile ? '18px 14px 34px' : '28px 18px 50px',
      }}
    >
      <Grid item xs={12}>
        <Typography
          style={{
            textAlign: 'center',
            paddingTop: isMobile ? '10px' : '18px',
            paddingBottom: isMobile ? '14px' : '22px',
            fontSize: isMobile ? '26px' : '34px',
            fontWeight: 800,
            letterSpacing: '-0.5px',
          }}
        >
          Boas Práticas
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, minmax(0, 1fr))',
          gap: isMobile ? '14px' : '22px',
          maxWidth: '1200px',
          margin: '0 auto',
          width: '100%',
        }}
      >
        {cardsData.map((card, index) => (
          <Link
            key={index}
            href={card.link}
            underline="none"
            style={{
              width: '100%',
              color: 'inherit',
              display: 'block',
            }}
          >
            <div
              style={{
                backgroundColor: '#fff',
                borderRadius: '16px',
                overflow: 'hidden',
                boxShadow: '0 6px 18px rgba(0,0,0,0.08)',
                width: '100%',
                maxWidth: cardWidth,
                margin: isMobile ? '0 auto' : '0',
                cursor: 'pointer',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div style={{ height: 140, width: '100%' }}>
                <img
                  src={card.image}
                  alt=""
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                  }}
                />
              </div>

              <CardContent style={{ padding: '14px 16px 18px', flex: 1 }}>
                <Typography
                  style={{
                    fontSize: isMobile ? '14px' : '16px',
                    lineHeight: 1.4,
                    fontWeight: 600,
                    color: 'var(--azul-card)',
                  }}
                >
                  {card.content}
                </Typography>
              </CardContent>
            </div>
          </Link>
        ))}
      </Grid>
    </Grid>
  );
};

export default BoasPraticas;